import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { anantaContext } from "./Home";

import bukuframe from "../../Assets/AsetAnanta/bukuFrame.png";
import buku1 from "../../Assets/AsetAnanta/buku1.png";
import buku2 from "../../Assets/AsetAnanta/buku2.png";
import buku3 from "../../Assets/AsetAnanta/buku3.png";
import buku4 from "../../Assets/AsetAnanta/buku4.png";

import kupu1 from "../../Assets/AsetAnanta/kupu1.png";
import kupu2 from "../../Assets/AsetAnanta/kupu2.png";
import kupu3 from "../../Assets/AsetAnanta/kupu3.png";


const Buku = () => {
  const nav = useNavigate();
  const soundRef = useRef(null);
  const bukuRef = useRef(null);
  const { click, setClick, end } = useContext(anantaContext);
  const [kupu, setKupu] = useState(0);

  const handleClick = () => {
    if (!click) {
      soundRef.current.play();
      setClick(1);
    }

    setKupu(1);
    setTimeout(() => {
      setKupu(2);
      setTimeout(() => {
        setKupu(3);
      }, 232);
    }, 232);

    setTimeout(() => {
      setKupu(0);
      setClick(2);
      setTimeout(() => {
        setClick(3);
      }, 500);
      setTimeout(() => {
        nav("/hari-pelaksanaan");
      }, 1000);
    }, 700);
  };

  return (
    <div ref={bukuRef} id="BukuAnanta">
      {/* <img style={{ width: click == 2 && "200vw" }} className="bg" /> */}
      <div style={{ opacity: click >= 2 && "0" }} className="box-buku">
        <div onClick={() => handleClick()} className="buku relative">
          <img
            style={{ opacity: kupu == 1 && "1" }}
            className="kupu1"
            src={kupu1}
          />
          <img
            style={{ opacity: click >= 1 && "0" }}
            className={end ? "imgBuku3" : "imgBukuIlang"}
            src={buku1}
          />
          <img
            style={{ opacity: click >= 1 && "1" }}
            className={click ? "clickBuku" : "imgBuku"}
            src={bukuframe}
            alt="buku1"
          />
          <audio ref={soundRef}>
            <source src="/Assets/sound/flipBook.mp3" type="audio/mp3" />
          </audio>
        </div>
      </div>
      <img
        className={click == 2 ? "zoomImg" : "imgBuku2"}
        src={buku4}
      />
      <div style={{ opacity: !click && end && "1" }} className="text-tekan">
        Tekan Buku Ananta untuk Melihat Lebih Lanjut
      </div>
      <img
        style={{ opacity: kupu == 2 && "1" }}
        className="kupu2"
        src={kupu2}
      />
      <img
        style={{ opacity: kupu == 3 && "1" }}
        className="kupu3"
        src={kupu3}
      />
    </div>
  );
};

export default Buku;
